import { render, staticRenderFns } from "./TotalColumnMeasureTab.vue?vue&type=template&id=4664db4a&scoped=true"
import script from "./TotalColumnMeasureTab.vue?vue&type=script&lang=js"
export * from "./TotalColumnMeasureTab.vue?vue&type=script&lang=js"
import style0 from "./TotalColumnMeasureTab.vue?vue&type=style&index=0&id=4664db4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4664db4a",
  null
  
)

export default component.exports